import { ErrorMessage as HookFormErrorMessage } from '@hookform/error-message';
import type { ComponentProps } from 'react';

export type ErrorMessageProps = Pick<
  ComponentProps<typeof HookFormErrorMessage>,
  'errors' | 'name'
>;

export const ErrorMessage = ({ errors, name }: ErrorMessageProps) => {
  return (
    <HookFormErrorMessage
      errors={errors}
      name={name}
      render={({ message }) => (
        <span className="text-ds-danger-400 font-ds-inter text-ds-200 font-ds-light tracking-ds-tight leading-ds-200">
          {message}
        </span>
      )}
    />
  );
};
